export const usuarios = {
  title: 'Gestão de usuários',
  description: 'Busque usuários para atribuir perfis ou alterar o acesso.',
  searchPlaceholder: 'Buscar por nome ou e-mail...',
  email: 'E-mail',
  perfis: 'Perfis',
  empty: {
    idle: 'Digite para buscar usuários.',
    semResultados: 'Nenhum usuário encontrado.',
  },
  acoes: {
    label: 'Ações',
    promover: 'Atribuir perfil',
    inativar: 'Inativar',
    reativar: 'Reativar',
  },
  promover: {
    title: 'Atribuir perfil',
    description:
      'Adicione um perfil a {{name}}. A operação é aditiva: perfis existentes são mantidos.',
    selecioneLabel: 'Perfil',
    selecionePlaceholder: 'Selecione um perfil',
    confirmar: 'Atribuir',
    sucesso: 'Perfil atribuído com sucesso.',
    erroAlvoInexistente: 'Usuário não encontrado.',
    erroRoleInvalido: 'Perfil inválido.',
  },
  inativar: {
    title: 'Inativar usuário',
    description: 'Inativar {{name}}? O acesso será revogado, mas o histórico é preservado.',
    sucesso: 'Usuário inativado.',
  },
  reativar: {
    title: 'Reativar usuário',
    description: 'Reativar {{name}}? O acesso será restaurado com os perfis preservados.',
    sucesso: 'Usuário reativado.',
  },
} as const;
